// Flip to true when App Store / Google Play links are live.
export const APP_IS_LIVE = false;

export const APP_STORE_URL = "#contact";
export const GOOGLE_PLAY_URL = "#contact";
export const WAITLIST_HREF = "/contact#download";
